const CASE_STUDIES = [
  {
    id: 'catalan-coast',
    label: 'Catalan Coast',
    buttonLabel: 'Go to case study 1',
    description: 'Case  Study 1 focuses on the Catalan Coast, including 2 different coastal settings: Barcelona urban beaches and the Ebro Delta. This case study addresses coastal pressures linked to urbanisation, tourism, agriculture, aquaculture, biodiversity change and water quality.',
    detailTitle: 'Case study 1: Catalan Coast',
    imageAlt: 'Catalan Coast case study',
    imagePath: '/img/misc/barcelona-case-study.png',
    locationName: 'Catalan Coast',
    coordinates: [1.368415875619435, 41.132393661592616],
  },
  {
    id: 'pagasitikos-gulf',
    label: 'Pagasitikos Gulf',
    buttonLabel: 'Go to case study 2',
    description: 'Case Study 2 focuses on the Pagasitikos Gulf, where ENHANCE investigates post-flood coastal recovery following  the 2023 Thessaly flood event through Earth Observation products, in-situ measurements, microbiological evidence, aquatic animal-health information and stakeholder-relevant recovery indicators.',
    detailTitle: 'Case study 2: Pagasitikos Gulf',
    imageAlt: 'Pagasitikos Gulf case study',
    imagePath: '/img/misc/pagasitikos-case-study.png',
    locationName: 'Pagasitikos Gulf',
    coordinates: [23.00910584018645, 39.222059961347043],
  },
];

export {
  CASE_STUDIES,
};
